// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"254534a4","109":"37754076","310":"734de5cb","341":"c1673f71","374":"0b1f7bac","488":"a4e665a4","531":"49c7a0c8","919":"5b6e1079"}[chunkId] + ".css";
};